import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['map']
  static values = {
    deliveryLocationAddress: String,
    drivers: Array,
    pickupLocationAddress: String
  }

  connect() {
    this.setup()
  }

  async setup() {
    const { Map } = await google.maps.importLibrary('maps')

    const map = new Map(this.mapTarget, {
      mapId: 'b861cb02f21004a9'
    })

    await this.calculateAndDisplayRoute(map)
    this.setDriverMarkers(map)
  }

  async calculateAndDisplayRoute(map) {
    const { Route } = await google.maps.importLibrary('routes')

    try {
      // Define the routes request
      const request = {
        origin: this.pickupLocationAddressValue,
        destination: this.deliveryLocationAddressValue,
        travelMode: 'DRIVING',
        fields: ['viewport', 'path'] // Request fields needed for bounds and polylines
      }

      // Call computeRoutes to get the directions
      const { routes } = await Route.computeRoutes(request)

      if (!routes || routes.length === 0) {
        window.alert('No routes found.')
        return
      }

      const route = routes[0]

      // Use createPolylines to create polylines for the route
      const mapPolylines = route.createPolylines()

      // Add polylines to the map
      mapPolylines.forEach(polyline => {
        polyline.setMap(map)
      })

      // Create start and end markers
      const markers = await route.createWaypointAdvancedMarkers()

      // Add markers to the map
      markers.forEach(marker => {
        marker.map = map
      })

      // Fit map to route bounds
      if (route.viewport) {
        map.fitBounds(route.viewport)
      }
    } catch (error) {
      console.error('Directions error:', error)
      window.alert('Directions request failed: ' + error.message)
    }
  }

  async setDriverMarkers(map) {
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')

    this.driversValue.map(driver => {
      const driverMarker = document.createElement('div')
      driverMarker.classList.add('driver-marker', 'map-marker')
      driverMarker.textContent = [driver.first_name, driver.last_name].join(' ')

      return new AdvancedMarkerElement({
        content: driverMarker,
        map,
        position: {
          lat: driver.driver_detail.latitude,
          lng: driver.driver_detail.longitude
        }
      })
    })
  }
}
